import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import {
  faCreditCard,
  faTableTennis,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';

type HeaderImageProps = {
  caption: string;
  icon: IconDefinition;
  isOrange?: boolean;
};

const HeaderImage: React.FC<HeaderImageProps> = ({
  caption,
  icon,
  isOrange = false,
}) => {
  return (
    <div className="z-10 flex w-[90px] flex-col items-center">
      <div
        className={classnames(
          'flex h-12 w-12 items-center justify-center rounded-full text-white',
          isOrange ? 'bg-orange-600' : 'bg-gray-300',
        )}
      >
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="mt-3 text-xs font-bold text-gray-400">{caption}</div>
    </div>
  );
};

const Component: React.FC = () => {
  return (
    <div className="flex flex-col items-center">
      <div className="text-center text-3xl font-black leading-8 text-orange-600">
        新規会員登録
      </div>
      <div className="relative my-6 flex justify-center md:gap-x-5">
        <HeaderImage isOrange icon={faUser} caption="アカウント作成" />
        <HeaderImage icon={faEnvelope} caption="メール確認" />
        <HeaderImage icon={faCreditCard} caption="お支払い" />
        <HeaderImage icon={faTableTennis} caption="利用開始" />
        <div className="absolute mt-[24px] flex h-0.5 w-[calc(100%-50px)] bg-gray-300"></div>
      </div>
    </div>
  );
};

export default Component;
